import React from 'react';
import { Cushion, ShimmerIcon, ShimmerTypography, Space } from '@pitchero/react-ui';

const MatchDetailsLoadingState = () => (
  <Cushion all="medium">
    <ShimmerTypography preset="tab--active" width="40%" />
    <Space vertical="medium">
      <ShimmerTypography preset="subtitle--small" width="30%" />
      <ShimmerIcon preset="body--large" style={{ marginRight: 12 }} inline />
      <ShimmerTypography preset="body--large" width="30%" inline />
    </Space>

    <Space vertical="medium">
      <ShimmerTypography preset="subtitle--small" width="30%" />
      <ShimmerIcon preset="body--large" style={{ marginRight: 12 }} inline />
      <ShimmerTypography preset="body--large" width="30%" inline />
    </Space>
  </Cushion>
);

export default MatchDetailsLoadingState;
